import { render } from "./HFregulation.vue?vue&type=template&id=060b1951&scoped=true"
import script from "./HFregulation.vue?vue&type=script&lang=js"
export * from "./HFregulation.vue?vue&type=script&lang=js"

import "./HFregulation.vue?vue&type=style&index=0&id=060b1951&lang=scss&scoped=true"
import "./HFregulation.vue?vue&type=style&index=1&id=060b1951&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-060b1951"]])

export default __exports__